import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "wrench"
const WrenchIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M10.182 3.367C12.45 1.101 15.864.681 18.555 2.107L19.004 2.345 14.644 6.705C14.498 6.85 14.498 7.089 14.644 7.235L16.235 8.825C16.363 8.955 16.561 8.97 16.707 8.874L16.766 8.826 21.156 4.435 21.4 4.86C22.963 7.582 22.585 11.117 20.258 13.444L20.072 13.622C18.127 15.435 15.416 15.953 13.031 15.186L6.2 22.015 6.06 22.143C5.37 22.705 4.379 22.704 3.692 22.144L3.55 22.016 2.36 20.825C1.675 20.14 1.632 19.054 2.233 18.318L2.36 18.174 8.879 11.654C7.55 9.06 7.913 5.82 9.977 3.58zM16.335 2.892C14.55 2.532 12.625 3.046 11.243 4.428 9.473 6.197 9.129 8.853 10.213 10.97L10.714 11.942 3.42 19.235C3.275 19.381 3.275 19.618 3.421 19.765L4.61 20.954C4.758 21.101 4.995 21.1 5.14 20.954L12.618 13.476 13.49 13.756C15.439 14.385 17.656 13.925 19.198 12.384 20.645 10.934 21.138 8.89 20.674 7.037L17.827 9.887C17.094 10.618 15.907 10.617 15.174 9.886L13.585 8.295C12.852 7.564 12.85 6.376 13.583 5.644z" />
        </svg>
      }
    </span>
  )
}
export default WrenchIcon
